import iMISFetch from "@/utils/iMISFetch";
import { IQA_COUPONS, QUERY_ENDPOINT } from "@/store/constants";
import { getSortedCoupons } from "@/store/coupons";
import type { Coupon } from "@/store/types";

/**
 * GET /api/query?queryname=$/ASI/Store/CouponsAvailable[&Id={partyId}]
 *
 * Returns the member's available coupons, sorted by soonest expiry first. The
 * party ID is passed explicitly so the IQA returns coupons for the correct
 * party even after an onbehalfof session ends (the server session may still
 * be scoped to the impersonated member). Returns [] on a successful-but-empty
 * response; throws on network/5xx.
 */
export async function fetchAvailableCoupons(partyId: string): Promise<Coupon[]> {
  const result = await iMISFetch<Coupon>(QUERY_ENDPOINT, { query: `${IQA_COUPONS}&Id=${partyId}`, limit: 0 });
  if (!result.success) {
    throw new Error(`fetchAvailableCoupons failed: ${result.message || "unknown error"}`);
  }
  const rows = Array.isArray(result.data) ? (result.data as Coupon[]) : [];
  return getSortedCoupons(rows);
}
